"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.concat_buf = exports.memcpy_buf = exports.get_count_pkt = exports.parse_data = void 0;
const bytes_deal_1 = require("./bytes_deal");
Object.defineProperty(exports, "memcpy_buf", { enumerable: true, get: function () { return bytes_deal_1.memcpy_buf; } });
Object.defineProperty(exports, "concat_buf", { enumerable: true, get: function () { return bytes_deal_1.concat_buf; } });
const code_convert_1 = require("./code_convert");
const LED_Head_TLV = 0x55AA;
const TYPE_CMD_TLV_Set = 0x02;
const TYPE_CMD_TLV_Get = 0x03;
const TYPE_CMD_TLV_Upgrade = 0x04;
const TLV_LED_Power = 0x04;
const TLV_LED_Timing = 0x05;
const TLV_LED_Light = 0x06;
const TLV_LED_Delete = 0x08;
const TLV_LED_Dev_Info = 0x0A;
const TLV_LED_Advance = 0x1B;
const TLV_LED_Property_Pkt = 0x12;
const TLV_LED_Pkt = 0x13;
const TLV_LED_Dispatch_pgm = 0x18;
const TLV_LED_Show_dev = 0x29;
const TLV_LED_Pgm_flicker = 0x2D;
const TLV_LED_Rotate = 0x2F;
const TLV_LED_Game = 0x30;
const TLV_LED_RTDraw = 0x32;
const TLV_LED_Ani_num = 0x33;
const TLV_LED_bluetooth = 0x34;
const TLV_LED_pgm_key = 0x35;
const TLV_LED_pgm_play = 0x36;
const TLV_LED_Data_Save = 0x09;
const TLV_LED_ID_Program = 0x0C;
const TLV_LED_ID_Region = 0x0D;
const TLV_LED_ID_Item = 0x0E;
const TLV_LED_Property_Item = 0x11;
const TLV_LED_Animate = 0x14;
const TLV_LED_Border = 0x15;
const TLV_LED_Period = 0x16;
const TLV_LED_RTShow = 0x19;
const TLV_LED_Property_Pro_ex = 0x1C;
const TLV_LED_Property_Reg_ex = 0x1D;
const TLV_TYPE_Res_Item = 0x00;
const TLV_TYPE_Res_Upgrade = 0x01;
const ITEM_TLV_Text = 0x06;
const ITEM_TLV_Gif_src = 0x0A;
const TLV_LED_Text_color = 0;
const TLV_LED_Text_space = 4;
const L_Border_48_r = [TLV_LED_Border, 18, 10, 5, 8, 4, 3, 1, 8, 0x1C, 0x3E, 0x7F, 0, 0, 0, 0, 0, 0, 0, 0];
const L_Border_48_r_ex = [TLV_LED_Border, 102, 10, 5, 8, 4, 0, 1, 0, 0, 0, 0, 0, 0, 0, 0, 0, 255, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 255, 0, 0, 255, 0, 0, 255, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 255, 0, 0, 255, 0, 0, 255, 0, 0, 255, 0, 0, 255, 0, 0, 0, 0, 0, 0, 0, 0, 255, 0, 0, 255, 0, 0, 255, 0, 0, 255, 0, 0, 255, 0, 0, 255, 0, 0, 255, 0, 0, 0, 0, 0];
const L_Border_r1 = [TLV_LED_Border, 30, 10, 5, 8, 1, 0, 1, 0xFF, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0xFF, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
const L_Border_g1 = [TLV_LED_Border, 30, 10, 5, 8, 1, 0, 1, 0, 0xFF, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0xFF, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
const L_Border_rg1 = [TLV_LED_Border, 30, 10, 5, 8, 1, 0, 1, 0xFF, 0xFF, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0xFF, 0xFF, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
const L_Border_r4 = [TLV_LED_Border, 30, 10, 5, 8, 1, 0, 1, 0xFF, 0, 0, 0xFF, 0, 0, 0xFF, 0, 0, 0xFF, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
const L_Border_g4 = [TLV_LED_Border, 30, 10, 5, 8, 1, 0, 1, 0, 0xFF, 0, 0, 0xFF, 0, 0, 0xFF, 0, 0, 0xFF, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
const L_Border_rg4 = [TLV_LED_Border, 30, 10, 5, 8, 1, 0, 1, 0xFF, 0xFF, 0, 0xFF, 0xFF, 0, 0xFF, 0xFF, 0, 0xFF, 0xFF, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0];
const L_Border_r8 = [TLV_LED_Border, 30, 10, 3, 8, 1, 0, 1, 0xFF, 0, 0, 0xFF, 0, 0, 0xFF, 0, 0, 0xFF, 0, 0, 0xFF, 0, 0, 0xFF, 0, 0, 0xFF, 0, 0, 0xFF, 0, 0];
const L_Border_g8 = [TLV_LED_Border, 30, 10, 3, 8, 1, 0, 1, 0, 0xFF, 0, 0, 0xFF, 0, 0, 0xFF, 0, 0, 0xFF, 0, 0, 0xFF, 0, 0, 0xFF, 0, 0, 0xFF, 0, 0, 0xFF, 0];
const L_Border_rg8 = [TLV_LED_Border, 30, 10, 3, 8, 1, 0, 1, 0xFF, 0xFF, 0, 0xFF, 0xFF, 0, 0xFF, 0xFF, 0, 0xFF, 0xFF, 0, 0xFF, 0xFF, 0, 0xFF, 0xFF, 0, 0xFF, 0xFF, 0, 0xFF, 0xFF, 0];
var GSize_max_pkt_res_tlv = 1024;
var GSize_max_pkt_tlv = 1152;
var L_type_cmd = TYPE_CMD_TLV_Set;
var L_type_data = 0xC1;
var L_count_pkt = 0;
var LED_Item;
(function (LED_Item) {
    LED_Item[LED_Item["none"] = -1] = "none";
    LED_Item[LED_Item["text"] = 0] = "text";
    LED_Item[LED_Item["graphic"] = 1] = "graphic";
    LED_Item[LED_Item["text_pic"] = 2] = "text_pic";
    LED_Item[LED_Item["text_clock"] = 3] = "text_clock";
    LED_Item[LED_Item["text_timing"] = 4] = "text_timing";
    LED_Item[LED_Item["text_temp_humid"] = 5] = "text_temp_humid";
    LED_Item[LED_Item["text_audio"] = 6] = "text_audio";
    LED_Item[LED_Item["text_part"] = 7] = "text_part";
    LED_Item[LED_Item["text_weather"] = 8] = "text_weather";
    LED_Item[LED_Item["text_sensor"] = 9] = "text_sensor";
})(LED_Item || (LED_Item = {}));
;
function isArray(arr) {
    return (arr != null) && Object.prototype.toString.call(arr) === '[object Array]';
}
function get_json_number(obj, key, def) {
    if (typeof (obj[key]) == 'number')
        return obj[key];
    return def;
}
function calc_make_up_mod(value, mod) {
    var tmp = value % mod;
    if (tmp > 0)
        return value + mod - tmp;
    else
        return value;
}
function calc_count_mod(value, mod) {
    var ret = Math.floor(value / mod);
    if (value % mod > 0)
        ret++;
    return ret;
}
function bytes_write_period_hn(dst, offset, str) {
    var h0 = 0, n0 = 0, h1 = 23, n1 = 59;
    h0 = parseInt(str.substr(0, 2));
    n0 = parseInt(str.substr(3, 2));
    h1 = parseInt(str.substr(6, 2));
    n1 = parseInt(str.substr(9, 2));
    dst[offset] = h0;
    dst[offset + 1] = n0;
    dst[offset + 2] = h1;
    dst[offset + 3] = n1;
    return true;
}
function tlv_get_len_len(len) {
    if (len < 0x80) {
        return 1;
    }
    else if (len < 0x100) {
        return 2;
    }
    else {
        return 3;
    }
}
function tlv_write_len_len(dst, offset, len) {
    if (len < 0x80) {
        dst[offset] = len;
        return 1;
    }
    else if (len < 0x100) {
        dst[offset] = 0x81;
        dst[offset + 1] = len;
        return 2;
    }
    else {
        dst[offset] = 0x82;
        dst[offset + 1] = len & 0xff;
        dst[offset + 2] = (len >> 8) & 0xff;
        return 3;
    }
}
function get_type_item(pType) {
    if (null == pType || typeof (pType) != "string")
        return -1;
    var sl = ["text", "graphic", "text_pic", "text_clock", "text_timing", "text_temp_humid", "text_audio", "text_part", "text_weather"];
    for (var i = 0; sl.length - 1; i++) {
        if (sl[i] == pType)
            return i;
    }
    return -1;
}
function get_type_border(pBorder) {
    if (null == pBorder)
        return 0;
    return get_json_number(pBorder, "fixed_value", 0);
}
function get_len_border(type_fixed) {
    if (0 == type_fixed)
        return 0;
    if (type_fixed <= 9)
        return L_Border_r1.length;
    if (type_fixed > 0x30)
        return L_Border_48_r_ex.length;
    return 7;
}
function write_data_simple_tag(ret, pos, tag, value) {
    ret[pos] = tag;
    ret[pos + 1] = 1;
    ret[pos + 2] = value;
    return 3;
}
function write_data_ani(ret, pos, pInfo) {
    ret[pos] = TLV_LED_Animate;
    ret[pos + 1] = 3;
    ret[pos + 2] = pInfo.type_ani;
    ret[pos + 3] = pInfo.speed;
    ret[pos + 4] = pInfo.time_stay;
    return 5;
}
function write_data_item_info(ret, pos, id_pgm, id_rect, id_item, pInfo_ani, update_item, data_save) {
    var len = pos;
    if (update_item) {
        ret[len++] = TLV_LED_RTShow;
        ret[len++] = 0x04;
        ret[len++] = 0x02;
        ret[len++] = id_pgm;
        ret[len++] = id_rect;
        ret[len++] = id_item;
    }
    len += write_data_simple_tag(ret, len, TLV_LED_Data_Save, 1 - data_save);
    len += write_data_simple_tag(ret, len, TLV_LED_ID_Program, id_pgm);
    len += write_data_simple_tag(ret, len, TLV_LED_ID_Region, id_rect);
    len += write_data_simple_tag(ret, len, TLV_LED_ID_Item, id_item);
    if (null != pInfo_ani) {
        len += write_data_ani(ret, len, pInfo_ani);
        if (pInfo_ani.type_fixed_border > 0)
            len += write_data_border(ret, len, pInfo_ani.type_fixed_border, 9);
    }
    return len - pos;
}
function write_data_border(ret, pos, type_fixed, speed) {
    ret[pos] = TLV_LED_Border;
    var len = 0;
    if ((type_fixed <= 9 || type_fixed == 0x31)) {
        switch (type_fixed) {
            case 1: {
                bytes_deal_1.memcpy_buf(ret, pos, L_Border_r4, 0, L_Border_r4.length);
                len = L_Border_r4.length;
                break;
            }
            case 2: {
                bytes_deal_1.memcpy_buf(ret, pos, L_Border_g4, 0, L_Border_g4.length);
                len = L_Border_g4.length;
                break;
            }
            case 3: {
                bytes_deal_1.memcpy_buf(ret, pos, L_Border_rg4, 0, L_Border_rg4.length);
                len = L_Border_rg4.length;
                break;
            }
            case 4: {
                bytes_deal_1.memcpy_buf(ret, pos, L_Border_r1, 0, L_Border_r1.length);
                break;
            }
            case 5: {
                bytes_deal_1.memcpy_buf(ret, pos, L_Border_g1, 0, L_Border_g1.length);
                len = L_Border_g1.length;
                break;
            }
            case 6: {
                bytes_deal_1.memcpy_buf(ret, pos, L_Border_rg1, 0, L_Border_rg1.length);
                len = L_Border_rg1.length;
                break;
            }
            case 7: {
                bytes_deal_1.memcpy_buf(ret, pos, L_Border_r8, 0, L_Border_r8.length);
                len = L_Border_r8.length;
                break;
            }
            case 8: {
                bytes_deal_1.memcpy_buf(ret, pos, L_Border_g8, 0, L_Border_g8.length);
                len = L_Border_g8.length;
                break;
            }
            case 9: {
                bytes_deal_1.memcpy_buf(ret, pos, L_Border_rg8, 0, L_Border_rg8.length);
                len = L_Border_rg8.length;
                break;
            }
            case 0x31: {
                bytes_deal_1.memcpy_buf(ret, pos, L_Border_48_r_ex, 0, L_Border_48_r_ex.length);
                len = L_Border_48_r_ex.length;
                break;
            }
        }
        ret[2] = speed;
        return len;
    }
    if (type_fixed >= 16)
        ret[3] = 5;
    else if (type_fixed > 12)
        ret[3] = 1;
    else if (type_fixed > 9)
        ret[3] = 0;
    else if (type_fixed > 6)
        ret[3] = 3;
    else
        ret[3] = 5;
    ret[2] = speed;
    if (ret[3] < 2) {
        var color = (type_fixed - 9) % 3;
        ret[1] = 5;
        ret[4] = (color != 2) ? 0xff : 0;
        ret[5] = (color != 1) ? 0xff : 0;
        ret[6] = 0;
        return 7;
    }
    else if (type_fixed < 10) {
        ret[1] = 9;
        ret[4] = 8;
        ret[5] = 1;
        ret[6] = 3;
        ret[7] = 1;
        switch (type_fixed) {
            case 1: {
                ret[8] = 0x0f;
                ret[9] = 0x00;
                ret[10] = 0x00;
                break;
            }
            case 2: {
                ret[8] = 0x00;
                ret[9] = 0x0f;
                ret[10] = 0x00;
                break;
            }
            case 3: {
                ret[8] = 0x0f;
                ret[9] = 0x0f;
                ret[10] = 0x00;
                break;
            }
            case 4: {
                ret[8] = 0x11;
                ret[9] = 0x00;
                ret[10] = 0x00;
                break;
            }
            case 5: {
                ret[8] = 0x00;
                ret[9] = 0x11;
                ret[10] = 0x00;
                break;
            }
            case 6: {
                ret[8] = 0x11;
                ret[9] = 0x11;
                ret[10] = 0x00;
                break;
            }
            case 7: {
                ret[8] = 0xFF;
                ret[9] = 0x00;
                ret[10] = 0x00;
                break;
            }
            case 8: {
                ret[8] = 0x00;
                ret[9] = 0xFF;
                ret[10] = 0x00;
                break;
            }
            case 9: {
                ret[8] = 0xFF;
                ret[9] = 0xFF;
                ret[10] = 0x00;
                break;
            }
            default:
                break;
        }
        return 11;
    }
    else {
        len = L_Border_48_r.length;
        bytes_deal_1.memcpy_buf(ret, pos, L_Border_48_r, 0, len);
        ret[2] = speed;
        return len;
    }
}
function write_data_item_control(ret, pos, pControl) {
    if (null != pControl && typeof (pControl) == "object") {
        var tmp = get_json_number(pControl, "play_fixed_time", 0);
        if (0 == tmp) {
            ret[pos] = 0;
            tmp = get_json_number(pControl, "play_loop", 1);
        }
        else
            ret[pos] = 1;
        ret[pos + 1] = tmp & 0xFF;
        ret[pos + 2] = (tmp >> 8) & 0xFF;
    }
    else {
        ret[pos] = 0;
        ret[pos + 1] = 1;
        ret[pos + 2] = 0;
    }
    return 3;
}
function split_data_res(list, pSrc, len, count_pkt_src, param, ntype) {
    var lastPktSize = len % GSize_max_pkt_res_tlv;
    var ipos = 0;
    var len = GSize_max_pkt_res_tlv;
    var ibegin = 0;
    if (null != param) {
        list.unshift(param);
        ibegin++;
    }
    var count_pkt = count_pkt_src + ibegin;
    var tmp = new Uint8Array(13);
    tmp[0] = TLV_LED_Property_Pkt;
    tmp[1] = 7;
    bytes_deal_1.bytes_write_int(tmp, 2, count_pkt, 2, false);
    bytes_deal_1.bytes_write_int(tmp, 6, GSize_max_pkt_res_tlv, 2, false);
    tmp[8] = ntype;
    tmp[9] = TLV_LED_Pkt;
    var pos_len = 10;
    for (var i = ibegin; i < count_pkt; i++) {
        bytes_deal_1.bytes_write_int(tmp, 4, i, 2, false);
        if (i == count_pkt_src + ibegin - 1 && lastPktSize > 0)
            len = lastPktSize;
        var len_header = pos_len + tlv_write_len_len(tmp, pos_len, len);
        var ret = new Uint8Array(len_header + len);
        if (null == ret) {
            console.log("----split_data_res out of memory!\n");
            return false;
        }
        bytes_deal_1.memcpy_buf(ret, 0, tmp, 0, len_header);
        bytes_deal_1.memcpy_buf(ret, len_header, pSrc, ipos, len);
        list.unshift(ret);
        ipos += GSize_max_pkt_res_tlv;
    }
    return true;
}
function split_data_res_pgm(plist, pSrc, id_pgm, id_rect, id_item, data_save) {
    var lastPktSize = pSrc.length % GSize_max_pkt_res_tlv;
    var len = GSize_max_pkt_res_tlv;
    var count_pkt = calc_count_mod(pSrc.length, GSize_max_pkt_res_tlv);
    var tmp = new Uint8Array(25);
    write_data_simple_tag(tmp, 0, TLV_LED_Data_Save, 1 - data_save);
    write_data_simple_tag(tmp, 3, TLV_LED_ID_Program, id_pgm);
    write_data_simple_tag(tmp, 6, TLV_LED_ID_Region, id_rect);
    write_data_simple_tag(tmp, 9, TLV_LED_ID_Item, id_item);
    tmp[12] = TLV_LED_Property_Pkt;
    tmp[13] = 7;
    bytes_deal_1.bytes_write_int(tmp, 14, count_pkt, 2);
    bytes_deal_1.bytes_write_int(tmp, 18, GSize_max_pkt_res_tlv, 2);
    tmp[20] = TLV_TYPE_Res_Item;
    tmp[21] = TLV_LED_Pkt;
    var pos_len = 22;
    var ipos = 0;
    for (var i = 0; i < count_pkt; i++) {
        bytes_deal_1.bytes_write_int(tmp, 16, i, 2);
        if ((i == count_pkt - 1) && (lastPktSize > 0))
            len = lastPktSize;
        var len_header = pos_len + tlv_write_len_len(tmp, pos_len, len);
        var ret = new Uint8Array(len_header + len);
        bytes_deal_1.memcpy_buf(ret, 0, tmp, 0, len_header);
        bytes_deal_1.memcpy_buf(ret, len_header, pSrc, ipos, len);
        plist.unshift(ret);
        ipos += GSize_max_pkt_res_tlv;
    }
    return true;
}
function get_data_ani(pInfo, pAni, w_rc, h_rc) {
    pInfo.type_ani = 1;
    pInfo.speed = 10;
    pInfo.time_stay = 3;
    pInfo.interval = w_rc;
    if (null != pAni) {
        pInfo.time_stay = get_json_number(pAni, "time_stay", 3);
        pInfo.speed = get_json_number(pAni, "speed", 10) - 1;
        if (null != pAni.model_continue && typeof (pAni.model_continue) == "string") {
            var size_interval = get_json_number(pAni, "size_interval", -1);
            if (pAni.model_continue == "left")
                pInfo.type_ani = 0;
            else if (pAni.model_continue == "top") {
                pInfo.type_ani = 4;
                pInfo.interval = h_rc;
            }
            else if (pAni.model_continue == "right")
                pInfo.type_ani = 0x1B;
            if (size_interval >= 0)
                pInfo.interval = size_interval * pInfo.interval / 100;
            else {
                var pInterval = pAni.interval_head_tail;
                if (null != pInterval && typeof (pInterval) == "number" && pInterval <= pInfo.interval)
                    pInfo.interval = pInterval;
            }
        }
        else {
            var pAni_model = pAni.model_normal;
            if (null != pAni_model && typeof (pAni_model) == "number") {
                pInfo.type_ani = pAni_model;
                if (4 == pInfo.type_ani)
                    pInfo.interval = h_rc;
            }
            else {
                pAni_model = pAni.model_gif;
                if (null != pAni_model && typeof (pAni_model) == "number") {
                    pInfo.delay_frame = pAni_model * 10;
                    pInfo.time_stay = 0;
                }
            }
        }
    }
}
function write_data_property_item_graphic_gif_src(ret, pos, pControl) {
    ret[pos] = TLV_LED_Property_Item;
    ret[pos + 1] = 4;
    write_data_item_control(ret, pos + 2, pControl);
    ret[pos + 5] = ITEM_TLV_Gif_src;
    return 6;
}
function build_data_item_gif_src(plist, data_gif, id_pgm, id_rect, id_item, pInfo_ani, update_item, data_save, pControl) {
    var len = 17 + 6 + get_len_border(pInfo_ani.type_fixed_border);
    if (update_item)
        len += 6;
    var ret = new Uint8Array(len);
    var pos = write_data_item_info(ret, 0, id_pgm, id_rect, id_item, pInfo_ani, update_item, data_save);
    write_data_property_item_graphic_gif_src(ret, pos, pControl);
    plist.unshift(ret);
    return split_data_res_pgm(plist, data_gif, id_pgm, id_rect, id_item, data_save);
}
let L_tb_gamma = new Uint8Array(256);
let L_Gamma = 0.0;
function init_tb_gamma(gamma) {
    var f;
    if (L_Gamma == gamma)
        return;
    for (var i = 0; i < 256; ++i) {
        f = (i + 0.5) / 256;
        f = Math.pow(f, gamma);
        L_tb_gamma[i] = (f * 256 - 0.5);
    }
    L_Gamma = gamma;
}
function check_data_zero(buf, tag) {
    for (var i = 0; i < buf.length; i++) {
        if (buf[i] > 0) {
            return;
        }
    }
    console.log(tag, "check_data_zero failed!", buf.length);
}
function gamma_correct(pDest, offset_dst, pSrc, offset_src, w, h, w_line, gamma) {
    init_tb_gamma(gamma);
    for (var y = h - 1; y >= 0; y--) {
        var pos = w_line * y;
        for (var x = 0; x < w * 3; x++) {
            var c = pSrc[offset_src + pos + x];
            pDest[offset_dst + pos + x] = L_tb_gamma[c];
        }
    }
}
function add_data_graphic_gamma(graphic, pData_src, len_src, gamma) {
    if (pData_src[0] != 0x42 || pData_src[1] != 0x4d || len_src < 54)
        return 0;
    var w = bytes_deal_1.bytes_read_int(pData_src, 18, 4);
    var h = bytes_deal_1.bytes_read_int(pData_src, 22, 4);
    var iLen_width_src = calc_make_up_mod(w * 3, 4);
    var ret = iLen_width_src * h + 54;
    if (ret > len_src)
        return 0;
    if (0 == graphic.m_width || 0 == graphic.m_height) {
        graphic.m_width = w;
        graphic.m_height = h;
        graphic.m_count_page = 0;
        if (null != graphic.p_data)
            graphic.p_data = null;
    }
    if (0 == w || 0 == h)
        return 0;
    var iLen_width = calc_make_up_mod(graphic.m_width * 3, 4);
    var iLen_page = iLen_width * graphic.m_height;
    var iLen_cur = graphic.m_count_page * iLen_page;
    var iLen_all = 0;
    var count_page = 1;
    iLen_all = iLen_page * count_page;
    graphic.m_count_page += count_page;
    var pCur_data = null;
    if (null != graphic.p_data && iLen_cur > 0)
        pCur_data = graphic.p_data;
    graphic.p_data = new Uint8Array(iLen_cur + iLen_all);
    if (null != pCur_data) {
        bytes_deal_1.memcpy_buf(graphic.p_data, 0, pCur_data, 0, iLen_cur);
        pCur_data = null;
    }
    var pData = new Uint8Array(graphic.p_data.buffer, iLen_cur, iLen_all);
    if (graphic.m_width == w && graphic.m_height == h)
        gamma_correct(pData, 0, pData_src, 54, w, h, iLen_width, gamma);
    else {
        var w1 = graphic.m_width < w ? graphic.m_width : w;
        var h1 = graphic.m_height < h ? graphic.m_height : h;
        var d_x = (graphic.m_width - w) / 2;
        var d_y = (graphic.m_height - h) / 2;
        var s_x = 0;
        var s_y = 0;
        if (d_x < 0) {
            s_x = 0 - d_x;
            d_x = 0;
        }
        if (d_y < 0) {
            s_y = 0 - d_y;
            d_y = 0;
        }
        var iLen_width_ex = calc_make_up_mod(w1 * 3, 4);
        for (var y = 0; y < h1; ++y)
            gamma_correct(pData, (d_y + y) * iLen_width + d_x * 3, pData_src, 54 + (s_y + y) * iLen_width_src + s_x * 3, w1, 1, iLen_width_ex, gamma);
    }
    check_data_zero(graphic.p_data, "garphic.p_data");
    return ret;
}
function select_arr(value, arr, len_arr) {
    if (len_arr == 0) {
        return -1;
    }
    for (var i = 0; i < len_arr; i++) {
        if (arr[i] == value)
            return i;
    }
    return -1;
}
var L_arr = new Uint32Array(257);
var L_count_use = 0;
function build_palette(graphic, w, h, w_line_src, len_page_bmp) {
    var bOut = false;
    var len_bit = 1;
    var count = 1 << len_bit;
    L_count_use = 0;
    for (var i = 0; i < L_arr.length; i++)
        L_arr[0] = 0;
    for (var i = 0; i < graphic.m_count_page; i++) {
        var ptmp_src = new Uint8Array(graphic.p_data.buffer, i * len_page_bmp, len_page_bmp);
        for (var y = h - 1; y >= 0; y--) {
            var pline = new Uint8Array(ptmp_src.buffer, ptmp_src.byteOffset + w_line_src * y, w_line_src);
            for (var x = 0; x < w; x++) {
                var c = bytes_deal_1.bytes_read_int(pline, x * 3, 3, true);
                var index = select_arr(c, L_arr, L_count_use);
                if (index < 0) {
                    L_arr[L_count_use++] = c;
                    if (L_count_use > count) {
                        len_bit = len_bit << 1;
                        if (len_bit > 8) {
                            L_count_use = 0;
                            len_bit = 24;
                            bOut = true;
                            break;
                        }
                        count = 1 << len_bit;
                    }
                }
            }
            if (bOut)
                break;
        }
        if (bOut)
            break;
    }
    return len_bit;
}
function build_data_bmp_tlv(graphic, len_last_page) {
    var w = graphic.m_width;
    var h = graphic.m_height;
    var w_line_src = calc_make_up_mod(w * 3, 4);
    var len_page_bmp = w_line_src * h;
    var len_bit = build_palette(graphic, w, h, w_line_src, len_page_bmp);
    var w_dst_bmp = calc_count_mod(w * len_bit, 8);
    var len_data_page = w_dst_bmp * h;
    var len_data = len_data_page * graphic.m_count_page;
    var len_palette = len_bit <= 8 ? ((1 << len_bit) * 3) : 0;
    var ret = new Uint8Array(15 + len_palette + len_data);
    for (var i = 0; i < L_count_use; ++i) {
        bytes_deal_1.bytes_write_int(ret, 15 + i * 3, L_arr[i], 3);
    }
    ret[0] = 'Y'.charCodeAt(0);
    ret[1] = 'S'.charCodeAt(0);
    ret[2] = 'T'.charCodeAt(0);
    ret[3] = 'P'.charCodeAt(0);
    ret[4] = '0'.charCodeAt(0);
    ret[5] = '1'.charCodeAt(0);
    bytes_deal_1.bytes_write_int(ret, 6, graphic.m_width, 2);
    bytes_deal_1.bytes_write_int(ret, 8, graphic.m_height, 2);
    bytes_deal_1.bytes_write_int(ret, 10, graphic.m_count_page, 2);
    bytes_deal_1.bytes_write_int(ret, 12, len_last_page, 2);
    ret[14] = len_bit;
    var b = 0;
    var npos = 15 + len_palette;
    for (var i = 0; i < graphic.m_count_page; ++i) {
        var ptmp_src = new Uint8Array(graphic.p_data.buffer, i * len_page_bmp);
        for (var y = h - 1; y >= 0; y--) {
            var pline = new Uint8Array(ptmp_src.buffer, ptmp_src.byteOffset + w_line_src * y);
            if (len_bit == 24) {
                for (var x = 0; x < w; x++) {
                    ret[npos + x * 3] = pline[x * 3 + 2];
                    ret[npos + x * 3 + 1] = pline[x * 3 + 1];
                    ret[npos + x * 3 + 2] = pline[x * 3];
                }
                npos += w_dst_bmp;
                continue;
            }
            var pos_bit = 0;
            for (var x = 0; x < w; x++) {
                var c = bytes_deal_1.bytes_read_int(pline, x * 3, 3, true);
                var index = select_arr(c, L_arr, L_count_use);
                b = b | (index << pos_bit);
                pos_bit = pos_bit + len_bit;
                if (8 == pos_bit) {
                    ret[npos] = b;
                    npos++;
                    pos_bit = 0;
                    b = 0;
                }
            }
            if (pos_bit > 0) {
                ret[npos] = b;
                npos++;
                pos_bit = 0;
                b = 0;
            }
        }
    }
    return ret;
}
function build_data_item_graphic_base(plist, pInfo_ani, graphic, id_pgm, id_rect, id_item, update_item, data_save, len_last_page, pControl) {
    var data_gif = build_data_bmp_tlv(graphic, len_last_page);
    if (null != data_gif) {
        var ret = build_data_item_gif_src(plist, data_gif, id_pgm, id_rect, id_item, pInfo_ani, update_item, data_save, pControl);
        return ret;
    }
    else
        return false;
}
function build_data_item_graphic(plist, pItem, pInfo_ani, id_pgm, id_rect, id_item, w_rc, h_rc, gray, update_item, data_save, res) {
    var pControl = pItem.control;
    var bGif = get_json_number(pItem, "isGif", 0) == 1;
    if (bGif) {
        var data_gif = res;
        if (undefined != data_gif)
            return build_data_item_gif_src(plist, data_gif, id_pgm, id_rect, id_item, pInfo_ani, update_item, data_save, pControl);
        else {
            return false;
        }
    }
    var data_graphic = res;
    if (undefined == data_graphic) {
        console.log("invalid res!", data_graphic, res);
        return false;
    }
    var size_border = 0;
    if ((pInfo_ani.type_fixed_border > 0))
        size_border = 1 + (pInfo_ani.type_fixed_border >> 4);
    var graphic = {
        m_width: w_rc - 2 * size_border,
        m_height: h_rc - 2 * size_border,
        m_count_page: 0,
        p_data: null
    };
    var gamma = gray > 0 ? 1.6 : 1;
    if (null != pItem.gamma && typeof (pItem.gamma) == "number")
        gamma = pItem.gamma;
    var len_graphic = data_graphic.length;
    var ipos = 0;
    while (ipos < len_graphic) {
        var len_bmp = add_data_graphic_gamma(graphic, new Uint8Array(data_graphic.buffer, ipos), len_graphic - ipos, gamma);
        if (0 == len_bmp)
            break;
        ipos += len_bmp;
    }
    if (0 == graphic.m_count_page) {
        console.log("graphic.m_count_page = 0!", graphic);
        return false;
    }
    var len_last_page = get_json_number(pItem, "len_valid", pInfo_ani.type_ani == 4 ? h_rc : w_rc);
    var arr_delay = null;
    if (bGif) {
        if (pInfo_ani.time_stay != 0) {
            pInfo_ani.delay_frame = pInfo_ani.time_stay * 10;
            pInfo_ani.time_stay = 0;
        }
        if (isArray(pItem.delay_frame)) {
            var size = pItem.delay_frame.length;
            if (size > 1) {
                arr_delay = new Uint8Array(size * 2);
                for (var i = 0; i < size; ++i) {
                    var delay_frame = pItem.delay_frame[i] * 10;
                    arr_delay[i * 2] = delay_frame & 0xff;
                    arr_delay[i * 2 + 1] = (delay_frame >> 8) & 0xff;
                }
            }
            else if (1 == size)
                pInfo_ani.delay_frame = pItem.delay_frame[0] * 10;
        }
    }
    var ret = build_data_item_graphic_base(plist, pInfo_ani, graphic, id_pgm, id_rect, id_item, update_item, data_save, len_last_page, pControl);
    return ret;
}
function write_data_text_color(ret, offset, color, color_bg) {
    ret[offset] = TLV_LED_Text_color;
    bytes_deal_1.bytes_write_int(ret, offset + 1, color, 3);
    bytes_deal_1.bytes_write_int(ret, offset + 4, color_bg, 3);
    return 7;
}
function get_align(pItem, def) {
    var h = 0, v = 0;
    var ptmp = pItem["align_horizontal"];
    if (null != ptmp) {
        if (ptmp == "left")
            h = 0;
        else if (ptmp == "center")
            h = 1;
        else
            h = 2;
    }
    else
        h = def & 0x0f;
    ptmp = pItem["align_vertical"];
    if (null != ptmp) {
        if (ptmp == "top")
            v = 0x00;
        else if (ptmp == "center")
            v = 0x10;
        else
            v = 0x20;
    }
    else
        v = (def & 0xf0);
    return v | h;
}
function write_data_text_align(ret, offset, align, bAlign_font) {
    ret[offset + 0] = 3;
    ret[offset + 1] = 1;
    ret[offset + 2] = align & 0X0f;
    ret[offset + 3] = 3;
    ret[offset + 4] = 0;
    ret[offset + 5] = (align >> 4) & 0x0f;
    if (bAlign_font) {
        ret[offset + 6] = 3;
        ret[offset + 7] = 2;
        ret[offset + 8] = 1;
        return 9;
    }
    else
        return 6;
}
function write_data_text_rotate(ret, offset, type_rotate) {
    ret[offset] = 2;
    ret[offset + 1] = type_rotate;
    return 2;
}
function write_data_space(ret, offset, type_space, space) {
    ret[offset] = TLV_LED_Text_space;
    ret[offset + 1] = type_space;
    ret[offset + 2] = space;
    return 3;
}
function write_data_property_item_text(ret, offset, size_font, interval, type_text, rotate, pControl) {
    ret[offset + 0] = TLV_LED_Property_Item;
    ret[offset + 1] = 10;
    write_data_item_control(ret, offset + 2, pControl);
    ret[offset + 5] = type_text;
    ret[offset + 6] = 1;
    ret[offset + 7] = 0;
    ret[offset + 8] = size_font;
    ret[offset + 9] = rotate == 90 ? 3 : 0;
    bytes_deal_1.bytes_write_int(ret, offset + 10, interval, 2);
    return 12;
}
function build_data_item_text(plist, pItem, pInfo_ani, id_pgm, id_rect, id_item, type_item, update_item, data_save) {
    var text_gb2312 = code_convert_1.utf8_bytes_gb(pItem["text"]);
    if (text_gb2312.length == 0) {
        return false;
    }
    var len_new = text_gb2312.length;
    var npos = 0;
    var len_header = 7 + 6;
    var rotate = get_json_number(pItem, "rotate", 0);
    var space_line = get_json_number(pItem, "space_line", 0);
    var space_font = get_json_number(pItem, "space_font", 0);
    if (rotate > 0) {
        len_header += 2;
        if (270 == rotate)
            len_header += 3;
    }
    if (space_line != 0)
        len_header += 3;
    if (space_font != 0)
        len_header += 3;
    var type_text = ITEM_TLV_Text;
    var sdsText = new Uint8Array(0);
    switch (type_item) {
        case LED_Item.text_part:
        case LED_Item.text_weather:
        case LED_Item.text: {
            sdsText = new Uint8Array(len_header + len_new);
            bytes_deal_1.memcpy_buf(sdsText, len_header, text_gb2312, 0, len_new);
            break;
        }
        default:
            break;
    }
    if (sdsText.length == 0) {
        return false;
    }
    var size_font = get_json_number(pItem, "size", 0);
    var color_font = get_json_number(pItem, "color", 255);
    npos = npos + write_data_text_color(sdsText, npos, color_font, 0);
    var align = get_align(pItem, 0);
    if (rotate == 90 && align != 0x11) {
        var align_h = align & 0x0f;
        var align_v = (align >> 4) & 0x0f;
        align = (align_h << 4) + align_v;
    }
    npos += write_data_text_align(sdsText, npos, align, rotate == 270);
    if (rotate > 0)
        npos += write_data_text_rotate(sdsText, npos, (rotate / 90) % 4);
    if (space_line > 0)
        npos += write_data_space(sdsText, npos, 0, space_line);
    if (space_font > 0)
        npos += write_data_space(sdsText, npos, 1, space_font);
    var len = 12 + 5 + get_len_border(pInfo_ani.type_fixed_border) + 12;
    if (update_item)
        len += 6;
    var ret = new Uint8Array(len);
    npos = write_data_item_info(ret, 0, id_pgm, id_rect, id_item, pInfo_ani, update_item, data_save);
    write_data_property_item_text(ret, npos, size_font, pInfo_ani.interval, type_text, rotate, pItem["control"]);
    plist.unshift(ret);
    return split_data_res_pgm(plist, sdsText, id_pgm, id_rect, id_item, data_save);
}
function build_data_item(plist, pItem, id_pgm, id_rect, id_item, w_rc, h_rc, gray, update_item, data_save, res) {
    var type = get_type_item(pItem.type_item);
    var info_ani = {
        time_stay: 3,
        type_ani: 1,
        speed: 10,
        interval: 0,
        delay_frame: 65535,
        type_fixed_border: 0
    };
    info_ani.type_fixed_border = get_type_border(pItem.info_border);
    get_data_ani(info_ani, pItem.info_animate, w_rc, h_rc);
    if (LED_Item.none == type) {
        console.log("build_data_item failed as type none!", pItem.type_item);
        return false;
    }
    if (LED_Item.graphic == type) {
        if (0 == w_rc || 0 == h_rc)
            return false;
        var ret = build_data_item_graphic(plist, pItem, info_ani, id_pgm, id_rect, id_item, w_rc, h_rc, gray, update_item, data_save, res);
        return ret;
    }
    else
        return build_data_item_text(plist, pItem, info_ani, id_pgm, id_rect, id_item, type, update_item, data_save);
}
function build_data_period(pPeriod, type) {
    if (null == pPeriod || typeof (pPeriod) != "object")
        return null;
    var parr = pPeriod.period;
    var pdate = pPeriod.date_play;
    var week = 0x7F;
    if (isArray(pPeriod.week)) {
        var weeks = pPeriod.week;
        week = 0;
        for (var i = 0; i < weeks.length; i++)
            week |= (1 << (weeks[i] - 1));
    }
    var y0 = 2000, m0 = 1, d0 = 1, y1 = 2099, m1 = 12, d1 = 31;
    if (null != pdate && typeof (pdate) == "string" && pdate.length == 21) {
        y0 = parseInt(pdate.slice(0, 4));
        m0 = parseInt(pdate.slice(5, 7));
        d0 = parseInt(pdate.slice(8, 10));
        y1 = parseInt(pdate.slice(11, 15));
        m1 = parseInt(pdate.slice(16, 18));
        d1 = parseInt(pdate.slice(19, 21));
    }
    var count = 0;
    if (isArray(parr))
        count = parr.length;
    var len = count * 4 + 11;
    var len_len = tlv_get_len_len(len);
    var ret = new Uint8Array(1 + len_len + len);
    ret[0] = TLV_LED_Period;
    tlv_write_len_len(ret, 1, len);
    var pos = len_len + 1;
    ret[pos++] = type;
    bytes_deal_1.bytes_write_int(ret, pos, y0, 2, false);
    pos += 2;
    ret[pos++] = m0;
    ret[pos++] = d0;
    bytes_deal_1.bytes_write_int(ret, pos, y1, 2, false);
    pos += 2;
    ret[pos++] = m1;
    ret[pos++] = d1;
    ret[pos++] = week;
    ret[pos++] = count;
    for (var i = 0; i < count; ++i)
        bytes_write_period_hn(ret, pos + i * 4, parr[i]);
    return ret;
}
function build_data_rect(id_rect, w, h, pInfo, type_show) {
    var x = 0, y = 0;
    var w_rc = w;
    var h_rc = h;
    if (null != pInfo && typeof (pInfo) == "object") {
        w_rc = get_json_number(pInfo, "w", w);
        h_rc = get_json_number(pInfo, "h", h);
        x = get_json_number(pInfo, "x", 0);
        y = get_json_number(pInfo, "y", 0);
    }
    var ret = new Uint8Array(3 + 11);
    ret[0] = TLV_LED_ID_Region;
    ret[1] = 1;
    ret[2] = id_rect;
    ret[3] = TLV_LED_Property_Reg_ex;
    ret[4] = 9;
    bytes_deal_1.bytes_write_int(ret, 5, x, 2, false);
    bytes_deal_1.bytes_write_int(ret, 7, y, 2, false);
    bytes_deal_1.bytes_write_int(ret, 9, w_rc, 2, false);
    bytes_deal_1.bytes_write_int(ret, 11, h_rc, 2, false);
    ret[13] = type_show;
    return ret;
}
function build_data_property_pgm(pProperty, parr_rect, no_pgm, w, h, pBG, data_save, type_pgm) {
    var type_play = 0;
    var value_play = 1;
    var len_ppt = 6;
    if (type_pgm > 0 || get_json_number(pProperty, "play_cmd", 0) == 1) {
        type_play = 2;
        len_ppt = 4;
    }
    else {
        var pType_play = pProperty.play_fixed_time;
        if (null != pType_play && typeof (pType_play) == "number") {
            type_play = 1;
            value_play = pType_play;
        }
        else
            value_play = typeof (pProperty.play_loop) == "number" ? pProperty.play_loop : 1;
    }
    var len_all = 3 + 3 + 2 + len_ppt;
    if (no_pgm != 0xFF)
        len_all += 4;
    var arr_ret = [];
    var ret = new Uint8Array(len_all);
    var pos = 0;
    if (no_pgm != 0xFF) {
        ret[0] = TLV_LED_Delete;
        ret[1] = 2;
        ret[2] = 0;
        ret[3] = no_pgm;
        pos = 4;
    }
    pos += write_data_simple_tag(ret, pos, TLV_LED_Data_Save, 1 - data_save);
    pos += write_data_simple_tag(ret, pos, TLV_LED_ID_Program, no_pgm);
    var type_bg = 0;
    if (null != pBG)
        type_bg = get_json_number(pBG, "type_bg", 0);
    else
        type_bg = get_json_number(pProperty, "type_bg", 0);
    ret[pos++] = TLV_LED_Property_Pro_ex;
    ret[pos++] = len_ppt;
    ret[pos++] = type_bg;
    ret[pos++] = type_play;
    if (type_play != 2) {
        bytes_deal_1.bytes_write_int(ret, pos, value_play, 2, false);
        pos += 2;
    }
    var time_sync = get_json_number(pProperty, "time_sync", 3);
    bytes_deal_1.bytes_write_int(ret, pos, time_sync, 2, false);
    arr_ret.push(ret);
    var period_pgm = build_data_period(pProperty.info_period_pro, 0);
    if (null != period_pgm)
        arr_ret.push(period_pgm);
    var count_rect = 0;
    if (isArray(parr_rect))
        count_rect = parr_rect.length;
    if (count_rect > 0) {
        for (var i = 0; i < count_rect; ++i) {
            var pRect = parr_rect[i];
            var data = build_data_rect(i, w, h, pRect.info_pos, get_json_number(pRect, "background", 0));
            arr_ret.push(data);
        }
        if (null != pBG) {
            var data = build_data_rect(count_rect, w, h, pBG.info_pos, 1);
            arr_ret.push(data);
        }
    }
    else {
        var data = build_data_rect(count_rect, w, h, null, 1);
        ret = bytes_deal_1.concat_buf([ret, data]);
    }
    return bytes_deal_1.concat_buf(arr_ret);
}
function build_data_dispatch_pgm_ex(no_pgm, pProperty) {
    var ret = new Uint8Array(8);
    ret[0] = TLV_LED_Dispatch_pgm;
    ret[1] = 6;
    ret[2] = 2;
    ret[3] = no_pgm;
    ret[4] = 0;
    var value_play = 1;
    var pType_play = pProperty.play_fixed_time;
    if (null != pType_play && typeof (pType_play) == "number") {
        ret[5] = 1;
        value_play = pType_play;
    }
    else {
        ret[5] = 0;
        value_play = get_json_number(pProperty, "play_loop", 1);
    }
    bytes_deal_1.bytes_write_int(ret, 6, value_play, 2, false);
    return ret;
}
function build_data_pkts_pgm(plist, pPkt, no_pgm, res) {
    var pProperty_pgm = pPkt.property_pro;
    if (null == pProperty_pgm || typeof (pProperty_pgm) == null) {
        return false;
    }
    var w = get_json_number(pProperty_pgm, "width", 0);
    var h = get_json_number(pProperty_pgm, "height", 0);
    if (w <= 0 || h <= 0) {
        return false;
    }
    var type_color = get_json_number(pProperty_pgm, "type_color", 1);
    if (type_color <= 0)
        type_color = 1;
    var gray = 0;
    if (type_color > 0x0f) {
        gray = type_color >> 4;
        type_color = type_color & 0x0f;
    }
    else
        gray = get_json_number(pProperty_pgm, "gray", 0);
    var data_save = get_json_number(pPkt, "data_save", 0);
    var type_pgm = get_json_number(pProperty_pgm, "type_pro", 0);
    if (type_pgm > 0) {
        if (1 == type_pgm)
            data_save = 1;
        if (type_pgm < 4 && no_pgm < 95)
            no_pgm = 128 - type_pgm;
    }
    var parr_rect = pPkt.list_region;
    var pBG = pPkt.background;
    if (null == parr_rect || typeof (parr_rect) != "object" || (parr_rect.length <= 0 && pBG == null)) {
        console.log("invalid list_rect!");
        return false;
    }
    var ppt = build_data_property_pgm(pProperty_pgm, parr_rect, no_pgm, w, h, pBG, data_save, type_pgm);
    plist.unshift(ppt);
    var index_res = 0;
    for (var i = 0; i < parr_rect.length; ++i) {
        console.log('index_res:' + index_res);
        var pRect = parr_rect[i];
        var id_rect = get_json_number(pRect, "id_rect", i);
        var pInfo = pRect.info_pos;
        var w_rc = w;
        var h_rc = h;
        if (null != pInfo && typeof (pInfo) == "object") {
            if (typeof (pInfo.w) == "number")
                w_rc = pInfo.w;
            if (typeof (pInfo.h) == "number")
                h_rc = pInfo.h;
        }
        if (w_rc <= 0 || h_rc <= 0) {
            console.log("Err_LED_Invalid_wh_rect");
            return false;
        }
        var parr_item = pRect.list_item;
        if (null == parr_item || typeof (parr_item) != "object") {
            console.log("Err_LED_No_item");
            return false;
        }
        for (var j = 0; j < parr_item.length; ++j) {
            var pItem = parr_item[j];
            if (null == pItem || typeof (pItem) != "object") {
                console.log("Err_LED_Invalid_item");
                return false;
            }
            var id_item = get_json_number(pItem, "id_item", j);
            var res_cur = undefined;
            if (res != undefined && res.length > index_res)
                res_cur = res[index_res++];
            if (!build_data_item(plist, pItem, no_pgm, id_rect, id_item, w_rc, h_rc, gray, false, data_save, res_cur)) {
                console.log("build_data_item failed!");
                return false;
            }
        }
    }
    if (null != pBG) {
        var id_bg = get_json_number(pBG, "id_rect", parr_rect.length + 1) - 1;
        var w_bg = w;
        var h_bg = h;
        var pPos = pBG.info_pos;
        if (pPos != null) {
            if (typeof (pPos.w) == "number")
                w_bg = pPos.w;
            if (typeof (pPos.h) == "number")
                h_bg = pPos.h;
        }
        if (!build_data_item(plist, pBG, no_pgm, id_bg, 0, w_bg, h_bg, gray, false, data_save))
            return false;
    }
    if (plist.length > 1) {
        if (1 == get_json_number(pProperty_pgm, "show_now", 0) || type_pgm == 1) {
            var pShow = build_data_dispatch_pgm_ex(no_pgm, pProperty_pgm);
            plist.unshift(pShow);
        }
    }
    return plist.length > 1;
}
function merge_pkt(plist, sno, type_data, type_cmd) {
    var len_all = 0;
    var pos = 0;
    var count = plist.length;
    for (var i = 0; i < count; i++)
        len_all += plist[i].length;
    var ret = null;
    if (len_all > GSize_max_pkt_tlv) {
        var bChecksum = type_data >> 7 == 1;
        var len_cs = bChecksum ? 2 : 0;
        ret = new Uint8Array(len_all + (2 + 10 + len_cs) * count);
        for (var i = count - 1; i >= 0; i--) {
            var item = plist[i];
            var pkt = build_pkt(sno, item, type_data, type_cmd, 1);
            sno++;
            bytes_deal_1.memcpy_buf(ret, pos, pkt, 0, pkt.length);
            pos += pkt.length;
        }
    }
    else {
        var data = new Uint8Array(len_all);
        var pos = 0;
        for (var i = count - 1; i >= 0; i--) {
            var item = plist[i];
            var len = item.length;
            bytes_deal_1.memcpy_buf(data, pos, item, 0, len);
            pos += len;
        }
        ret = build_pkt(sno, data, type_data, type_cmd, 1);
    }
    return ret;
}
function build_data_pgm_key(plist, key, ts_key, no_pgm) {
    console.log("build_data_pgm_key 0:", key, ts_key);
    if (typeof (key) != "string" || key.length != 40)
        return;
    var arr_key = bytes_deal_1.hex_to_bytes(key, 2);
    console.log("build_data_pgm_key", key, key.length, ts_key, arr_key);
    if (arr_key.length != 20)
        return;
    var data = new Uint8Array(27);
    data[0] = TLV_LED_pgm_key;
    data[1] = 25;
    data[2] = no_pgm;
    for (var i = 0; i < 20; i++)
        data[i + 3] = arr_key[i];
    bytes_deal_1.bytes_write_int(data, 23, ts_key, 4);
    plist.unshift(data);
}
function build_data_pgm(pPkt, id_res, ts_update, sno, res) {
    if (null == pPkt || typeof (pPkt) != "object")
        return null;
    var no_pgm = get_json_number(pPkt, "id_pro", 0) - 1;
    if (no_pgm < 0) {
        console.log("invalid id_pro:", pPkt.id_pro);
        return null;
    }
    var plist = [];
    if (!build_data_pkts_pgm(plist, pPkt, no_pgm, res)) {
        console.log("build_data_pkts_pgm failed!\n");
        return null;
    }
    build_data_pgm_key(plist, id_res, ts_update, no_pgm);
    return merge_pkt(plist, sno, L_type_data, TYPE_CMD_TLV_Set);
}
function build_data_rt_show(rt_show, sno, res) {
    if (!isArray(rt_show.res_show) || rt_show.res_show.length < 1)
        return null;
    var no_pgm = get_json_number(rt_show, "id_pro", 1) - 1;
    var data_save = get_json_number(rt_show, "data_save", 1);
    var gray = get_json_number(rt_show, "gray", 0);
    var w = get_json_number(rt_show, "width", 0);
    var h = get_json_number(rt_show, "height", 0);
    var plist = [];
    var arr_r = [];
    var index_res = 0;
    for (var i = 0; i < rt_show.res_show.length; i++) {
        var pRect = rt_show.res_show[i];
        var pInfo = pRect.info_pos;
        var id_rect = get_json_number(pRect, "id_rect", i + 1) - 1;
        var w_rc = w;
        var h_rc = h;
        if (pInfo != null) {
            var data = build_data_rect(id_rect, w, h, pInfo, 1);
            arr_r.push(data);
            w_rc = get_json_number(pInfo, "w", w_rc);
            h_rc = get_json_number(pInfo, "h", h_rc);
        }
        var parr_item = pRect.list_item;
        if (!isArray(parr_item))
            continue;
        for (var j = 0; j < parr_item.length; ++j) {
            var pItem = parr_item[j];
            if (null == pItem || typeof (pItem) != "object") {
                console.log("Err_LED_Invalid_item");
                return null;
            }
            var id_item = get_json_number(pItem, "id_item", j + 1) - 1;
            var res_cur = undefined;
            if (res != undefined && res.length > index_res)
                res_cur = res[index_res++];
            if (!build_data_item(plist, pItem, no_pgm, id_rect, id_item, w_rc, h_rc, gray, true, data_save, res_cur)) {
                console.log("build_data_item failed!");
                return null;
            }
        }
    }
    if (arr_r.length > 0) {
        var tmp = new Uint8Array(3 + 3);
        write_data_simple_tag(tmp, 0, TLV_LED_Data_Save, 1 - data_save);
        write_data_simple_tag(tmp, 0, TLV_LED_ID_Program, no_pgm);
        arr_r.unshift(tmp);
        var ppt_rect = bytes_deal_1.concat_buf(arr_r);
        plist.push(ppt_rect);
    }
    return merge_pkt(plist, sno, L_type_data, TYPE_CMD_TLV_Set);
}
function build_data_param_dev(cmd) {
    var w, h;
    w = cmd.width;
    h = cmd.height;
    if (w <= 0 || h <= 0) {
        return null;
    }
    var len = 5;
    var ret = new Uint8Array(len + 2);
    ret[0] = TLV_LED_Advance;
    ret[1] = len;
    ret[2] = 1;
    bytes_deal_1.bytes_write_int(ret, 3, w, 2, false);
    bytes_deal_1.bytes_write_int(ret, 5, h, 2, false);
    return ret;
}
function build_data_property_upgrade(count_pkt, sdsInfo) {
    var len = sdsInfo.length;
    var ret = new Uint8Array(len + 12);
    if (null == ret) {
        return null;
    }
    ret[0] = TLV_LED_Property_Pkt;
    ret[1] = 7;
    bytes_deal_1.bytes_write_int(ret, 2, count_pkt, 2, false);
    ret[4] = 0;
    ret[5] = 0;
    bytes_deal_1.bytes_write_int(ret, 6, GSize_max_pkt_res_tlv, 2, false);
    ret[8] = TLV_TYPE_Res_Upgrade;
    ret[9] = TLV_LED_Pkt;
    ret[10] = len + 1;
    for (var i = 0; i < len; ++i) {
        ret[i + 11] = sdsInfo[i].charCodeAt(0);
        if (ret[i + 11] == 0x2C)
            ret[i + 11] = 0;
    }
    ret[len + 11] = 0;
    return ret;
}
function build_data_pkts_upgrade(info, src, sno) {
    var count_pkt = calc_count_mod(src.length, GSize_max_pkt_res_tlv);
    var list = [];
    var sdsProperty = build_data_property_upgrade(count_pkt + 1, info);
    if (null == sdsProperty)
        return null;
    if (!split_data_res(list, src, src.length, count_pkt, sdsProperty, TLV_TYPE_Res_Upgrade)) {
        console.log("split_data_res upgrade failed!");
        return null;
    }
    return merge_pkt(list, sno, L_type_data, TYPE_CMD_TLV_Upgrade);
}
function build_data_upgrade(upgrade, sno, res) {
    if (null == upgrade.model || typeof (upgrade.model) != 'string')
        return null;
    var strMd5 = upgrade.md5;
    var cs = 0;
    for (var i = 0; i < res.length; i++)
        cs += res[i];
    cs = cs & 0xFFFF;
    if (null != upgrade.checksum && typeof (upgrade.checksum) == 'number' && upgrade.checksum != cs) {
        console.log('buildData_upgrade failed as cs err!', cs, upgrade.checksum);
        return null;
    }
    var strinfo = ("000" + cs.toString(16)).slice(-4) + ',' + upgrade.model + ',00000000' + strMd5;
    return build_data_pkts_upgrade(strinfo, res, sno);
}
function build_data_power(power) {
    if (null == power['type'] || typeof (power['type']) != 'number')
        return null;
    var ret = null;
    if (null == power.period) {
        ret = new Uint8Array(4);
        ret[0] = TLV_LED_Power;
        ret[1] = 0x02;
        ret[2] = 0x00;
        ret[3] = power['type'];
        if (ret[3] > 1)
            ret[3] = 1;
        return ret;
    }
    else {
        do {
            var count = 1;
            if (isArray(power.period))
                count = power.period.length;
            else if (typeof (power.period) != 'string')
                break;
            if (count < 1)
                break;
            ret = new Uint8Array(4 + count * 4);
            ret[0] = TLV_LED_Power;
            ret[1] = 0x06;
            ret[2] = count;
            ret[3] = 0x7f;
            if (typeof (power.period) == 'string')
                bytes_write_period_hn(ret, 4, power.period);
            else
                for (var i = 0; i < count; ++i)
                    bytes_write_period_hn(ret, 4 + 4 * i, power.period[i]);
            return ret;
        } while (0);
        console.log("build_data_power failed as period invalid!");
        return null;
    }
}
function build_data_light(light) {
    if (null == light['type'] || typeof (light['type']) != 'number')
        return null;
    if (light['type'] == 0 || light['type'] == 2) {
        var ret = new Uint8Array(4);
        ret[0] = TLV_LED_Light;
        ret[1] = 2;
        ret[2] = light['type'];
        ret[3] = light.value_fix;
        if (ret[3] == 0)
            ret[3] = 15;
        return ret;
    }
    else if (light['type'] == 1) {
        var period = light.value_period;
        if (!isArray(period))
            return null;
        if (period.length <= 0)
            return null;
        var ret = new Uint8Array(3 + period.length * 3);
        ret[0] = TLV_LED_Light;
        ret[1] = 1 + period.length * 3;
        ret[2] = period.length;
        for (var i = 0; i < period.length; i++) {
            var pItem = period[i];
            if (null == pItem) {
                return null;
            }
            var hour = 0, min = 0;
            hour = pItem.time.substr(0, 2);
            min = pItem.time.substr(3, 2);
            var val = pItem.value;
            if (val <= 0)
                val = 15;
            ret[3 + i * 3] = val;
            ret[4 + i * 3] = hour;
            ret[5 + i * 3] = min;
        }
        return ret;
    }
    return null;
}
function build_data_show_dev(show) {
    var ret = new Uint8Array(3);
    ret[0] = TLV_LED_Show_dev;
    ret[1] = 1;
    ret[2] = show;
    return ret;
}
function build_data_pgm_flicker(pgm_flicker) {
    var ntype = get_json_number(pgm_flicker, "type", 0);
    if (ntype != 0) {
        console.log("unsuport type, build_data_pgm_flicker");
        return null;
    }
    var count = get_json_number(pgm_flicker, "count_pgm", 0);
    var ms = get_json_number(pgm_flicker, "time", 0);
    if (0 == ms) {
        count = 0;
    }
    var ret = new Uint8Array(8);
    ret[0] = TLV_LED_Pgm_flicker;
    ret[1] = 6;
    ret[2] = ntype;
    ret[3] = count;
    bytes_deal_1.bytes_write_int(ret, 4, ms, 4, false);
    return ret;
}
function build_data_rotate(rotate) {
    var val = rotate / 90;
    val = val % 4;
    var ret = new Uint8Array(3);
    ret[0] = TLV_LED_Rotate;
    ret[1] = 1;
    ret[2] = val;
    return ret;
}
var opt_game = { "left": 37, "up": 38, "right": 39, "down": 40, "start": 115, "pause": 112, "done": 100, "exit": 101 };
function build_data_game(game) {
    var val = 0;
    if (game.opt != undefined && typeof (game.opt) == "string" && opt_game[game.opt] != undefined)
        val = opt_game[game.opt];
    else
        val = game.id + 0x80;
    var ret = new Uint8Array(3);
    ret[0] = TLV_LED_Game;
    ret[1] = 1;
    ret[2] = val;
    return ret;
}
function build_data_ani_num(param) {
    var ntype = param["type"];
    var fmt = param.fmt;
    if (ntype == undefined || typeof (ntype) != "number" || fmt == undefined || typeof (fmt) != "number")
        return null;
    var len = 2;
    if (ntype == 1) {
        len += 3;
    }
    else if (ntype == 3) {
        len += 4;
    }
    var ret = new Uint8Array(2 + len);
    ret[0] = TLV_LED_Ani_num;
    ret[1] = len;
    ret[2] = ntype;
    ret[3] = fmt;
    if (ntype == 1) {
        if (param.h != undefined && typeof (param.h) == "number")
            ret[4] = param.h;
        if (param.m != undefined && typeof (param.m) == "number")
            ret[5] = param.m;
        if (param.s != undefined && typeof (param.s) == "number")
            ret[6] = param.s;
    }
    else if (ntype == 3) {
        if (param.score_r != undefined && typeof (param.score_r) == "number")
            bytes_deal_1.bytes_write_int(ret, 4, param.score_r, 2, false);
        if (param.score_b != undefined && typeof (param.score_b) == "number")
            bytes_deal_1.bytes_write_int(ret, 6, param.score_b, 2, false);
    }
    return ret;
}
function build_data_bluetooth(param) {
    var ntype = param["type"];
    var val = param.val;
    if (ntype == undefined || typeof (ntype) != "number" || val == undefined || typeof (val) != "number")
        return null;
    var ret = new Uint8Array(4);
    ret[0] = TLV_LED_bluetooth;
    ret[1] = 2;
    ret[2] = ntype;
    ret[3] = val;
    return ret;
}
function build_data_timing(param) {
    var t = new Date();
    if (typeof (param) == "string")
        t = new Date(param);
    var ret = new Uint8Array(11);
    ret[0] = TLV_LED_Timing;
    ret[1] = 9;
    bytes_deal_1.bytes_write_int(ret, 2, t.getFullYear() - 2000, 2, false);
    ret[4] = t.getMonth() + 1;
    ret[5] = t.getDate();
    ret[6] = t.getHours();
    ret[7] = t.getMinutes();
    ret[8] = t.getSeconds();
    bytes_deal_1.bytes_write_int(ret, 9, t.getMilliseconds(), 2, false);
    return ret;
}
function data_rect_to_byte(arr, x0, y0, x1, y1, w, h, color) {
    var len = 1 + 3 + 8 + h * calc_count_mod(w, 8);
    var len_len = tlv_get_len_len(len);
    var ret = new Uint8Array(1 + len_len + len);
    ret[0] = TLV_LED_RTDraw;
    tlv_write_len_len(ret, 1, len);
    ret[1 + len_len] = 0;
    bytes_deal_1.bytes_write_int(ret, 2 + len_len, color, 3, false);
    bytes_deal_1.bytes_write_int(ret, 5 + len_len, x0, 2, false);
    bytes_deal_1.bytes_write_int(ret, 7 + len_len, y0, 2, false);
    bytes_deal_1.bytes_write_int(ret, 9 + len_len, x1, 2, false);
    bytes_deal_1.bytes_write_int(ret, 11 + len_len, y1, 2, false);
    var index = 13 + len_len;
    for (var y = 0; y < h; y++) {
        var pos_line = y * w;
        var b = 0;
        var index_b = 7;
        for (var x = 0; x < w; x++) {
            b += (arr[pos_line + x] << index_b);
            if (index_b == 0) {
                ret[index++] = b;
                b = 0;
                index_b = 7;
            }
            else
                index_b--;
        }
        if (index_b < 7)
            ret[index++] = b;
    }
    return ret;
}
function build_data_RTDraw(rtdraw) {
    if (null == rtdraw['type'] || typeof (rtdraw['type']) != 'number')
        return null;
    if (null == rtdraw.color || typeof (rtdraw.color) != 'number')
        return null;
    if (rtdraw.type != 16) {
        if (null == rtdraw.x0 || typeof (rtdraw.x0) != 'number')
            return null;
        if (null == rtdraw.y0 || typeof (rtdraw.y0) != 'number')
            return null;
        if (null == rtdraw.x1 || typeof (rtdraw.x1) != 'number')
            return null;
        if (null == rtdraw.y1 || typeof (rtdraw.y1) != 'number')
            return null;
        if ((rtdraw.x0 > rtdraw.x1) || (rtdraw.y0 > rtdraw.y1))
            return null;
    }
    var ret = null;
    if (rtdraw['type'] == 0) {
        var arr = rtdraw.data;
        var w = (rtdraw.x1 - rtdraw.x0 + 1);
        var h = (rtdraw.y1 - rtdraw.y0 + 1);
        if (!isArray(arr) || arr.length != w * h)
            return null;
        ret = data_rect_to_byte(arr, rtdraw.x0, rtdraw.y0, rtdraw.x1, rtdraw.y1, w, h, rtdraw.color);
    }
    else if (rtdraw['type'] == 1) {
        if (null == rtdraw.type_rect || typeof (rtdraw.type_rect) != 'number')
            return null;
        if (rtdraw.type_rect != 0)
            return null;
        var len = 1 + 3 + 1 + 8;
        ret = new Uint8Array(2 + len);
        ret[0] = TLV_LED_RTDraw;
        ret[1] = len;
        ret[2] = 1;
        bytes_deal_1.bytes_write_int(ret, 3, rtdraw.color, 3, false);
        ret[6] = rtdraw.type_rect;
        bytes_deal_1.bytes_write_int(ret, 7, rtdraw.x0, 2, false);
        bytes_deal_1.bytes_write_int(ret, 9, rtdraw.y0, 2, false);
        bytes_deal_1.bytes_write_int(ret, 11, rtdraw.x1, 2, false);
        bytes_deal_1.bytes_write_int(ret, 13, rtdraw.y1, 2, false);
    }
    else if (rtdraw['type'] == 16) {
        var arr_pos = rtdraw.data;
        if (!isArray(arr_pos) || arr_pos.length < 1)
            return null;
        var item = arr_pos[0];
        if (!isArray(item) || item.length != 2)
            return null;
        var x0 = item[0], y0 = item[1], x1 = item[0], y1 = item[1];
        for (var i = 1; i < arr_pos.length; i++) {
            var item = arr_pos[i];
            if (!isArray(item) || item.length != 2) {
                return null;
            }
            if (x0 > item[0])
                x0 = item[0];
            else if (x1 < item[0])
                x1 = item[0];
            if (y0 > item[1])
                y0 = item[1];
            else if (y1 < item[1])
                y1 = item[1];
        }
        var w = x1 - x0 + 1;
        var h = y1 - y0 + 1;
        var arr_s = new Array(w * h);
        for (var i = 0; i < arr_s.length; i++)
            arr_s[i] = 0;
        for (var i = 0; i < arr_pos.length; i++) {
            var item = arr_pos[i];
            var index = (item[0] - x0) + (item[1] - y0) * w;
            arr_s[index] = 1;
        }
        ret = data_rect_to_byte(arr_s, x0, y0, x1, y1, w, h, rtdraw.color);
    }
    else {
        return null;
    }
    return ret;
}
function build_data_del(del) {
    var ret = null;
    if (1 == del.format) {
        ret = new Uint8Array(3);
        ret[0] = TLV_LED_Delete;
        ret[1] = 0x01;
        ret[2] = 0x03;
        return ret;
    }
    if (1 == del.del_all) {
        ret = new Uint8Array(4);
        ret[0] = TLV_LED_Delete;
        ret[1] = 0x02;
        ret[2] = 0x00;
        ret[3] = 255;
        return ret;
    }
    var pos = 0;
    var size = 0;
    var arr = del.del_ids;
    var len_len = 1;
    do {
        if (isArray(arr)) {
            size = arr.length;
            var len = 1 + size;
            len_len = tlv_get_len_len(len);
            ret = new Uint8Array(1 + len_len + len);
            tlv_write_len_len(ret, 1, len);
            ret[1 + len_len] = 0X00;
            pos = 2 + len_len;
            break;
        }
        var no_pgm = del.id_pro - 1;
        if (no_pgm < 0)
            break;
        arr = del.del_ids_rect;
        if (isArray(arr)) {
            size = arr.length;
            ret = new Uint8Array(4 + size);
            ret[2] = 0X01;
            ret[3] = no_pgm;
            pos = 4;
            break;
        }
        var no_rect = del.id_rect - 1;
        if (no_rect < 0)
            break;
        arr = del.del_ids_item;
        if (isArray(arr)) {
            size = arr.length;
            ret = new Uint8Array(5 + size);
            ret[2] = 0X02;
            ret[3] = no_pgm;
            ret[4] = no_rect;
            pos = 5;
            break;
        }
    } while (0);
    if (null != ret) {
        ret[0] = TLV_LED_Delete;
        tlv_write_len_len(ret, 1, ret.length - 1 - len_len);
        for (var i = 0; i < size; i++)
            ret[pos + i] = arr[i] - 1;
    }
    else
        console.log("build_data_del failed!\n");
    return ret;
}
function build_data_dispatch_pgm(dispatch) {
    var type = dispatch['type'];
    var model = 255, val = 1;
    var ignore = dispatch.ignore_pgm_cmd;
    var bDefault = false;
    var tmp = dispatch.play_fixed_time;
    if (typeof (tmp) == 'number') {
        model = 1;
        val = tmp;
    }
    else {
        tmp = dispatch.play_loop;
        if (typeof (tmp) == 'number') {
            model = 0;
            val = tmp;
        }
        else
            bDefault = true;
    }
    var ret = new Uint8Array(32);
    ret[0] = TLV_LED_Dispatch_pgm;
    var len = 0;
    switch (type) {
        case 0: {
            var pre_next = get_json_number(dispatch, "value", 0);
            if (0 == get_json_number(dispatch, "target", 0)) {
                ret[2] = pre_next;
                len = 1;
            }
            else {
                ret[2] = pre_next + 3;
                ret[3] = get_json_number(dispatch, 'id_pro', 1) - 1;
                ret[4] = get_json_number(dispatch, "id_rect", 1) - 1;
                len = 3;
            }
            break;
        }
        case 1: {
            var pid_item = dispatch.id_item;
            var id_pro = get_json_number(dispatch, "id_pro", 1) - 1;
            if (null == pid_item) {
                ret[2] = 2;
                ret[3] = id_pro;
                len = 2;
            }
            else {
                ret[2] = 5;
                ret[3] = id_pro;
                ret[4] = get_json_number(dispatch, "id_rect", 1) - 1;
                ret[5] = pid_item - 1;
                len = 4;
            }
            break;
        }
        case 2: {
            var pId_res = dispatch["id_res"];
            if (typeof (pId_res) != 'string' || pId_res.length != 40)
                return null;
            var id_res = bytes_deal_1.hex_to_bytes(pId_res, 2);
            ret[2] = 6;
            bytes_deal_1.memcpy_buf(ret, 3, id_res, 0, 20);
            len = 21;
            break;
        }
        default:
            return null;
    }
    ret[len + 2] = ignore;
    ret[len + 3] = model;
    if (bDefault)
        len = len + 2;
    else {
        bytes_deal_1.bytes_write_int(ret, len + 4, val, 2, false);
        len = len + 4;
    }
    ret[1] = len;
    return ret.slice(0, len + 2);
}
function build_data_pgm_play(cmd) {
    var model = get_json_number(cmd, "model", 0);
    var index = get_json_number(cmd, "index", 255);
    var len = 0;
    var arr = cmd["ids_pro"];
    if (isArray(arr)) {
        len = arr.length;
    }
    var ret = new Uint8Array(2 + 2 + len);
    ret[0] = TLV_LED_pgm_play;
    ret[1] = len + 2;
    ret[2] = model;
    ret[3] = index;
    for (var i = 0; i < len; i++) {
        ret[i + 4] = arr[i];
    }
    return ret;
}
function build_data_get(get) {
    var cmd = 0xff;
    var ret = null;
    if (typeof (get) == 'string') {
        if ("param_dev" == get)
            cmd = TLV_LED_Advance;
        else if ("power" == get)
            cmd = TLV_LED_Power;
        else if ("light" == get)
            cmd = TLV_LED_Light;
        else if ("dev_info" == get)
            cmd = TLV_LED_Dev_Info;
        else if ("rotate" == get)
            cmd = TLV_LED_Rotate;
        else if ("bluetooth" == get)
            cmd = TLV_LED_bluetooth;
        else {
            return null;
        }
        ret = new Uint8Array(2);
        ret[0] = cmd;
        return ret;
    }
    else {
        if (get != null && get["pgm_key"] != null && isArray(get["pgm_key"])) {
            var len = get["pgm_key"].length;
            if (len == 0)
                return null;
            if (len > 8)
                len == 8;
            ret = new Uint8Array(2 + len);
            ret[0] = TLV_LED_pgm_key;
            ret[1] = len;
            for (var i = 0; i < len; i++)
                ret[i + 2] = get["pgm_key"][i];
            return ret;
        }
    }
    return null;
}
function get_obj_cmd(cmd) {
    var arr = ["rt_show",
        "get",
        "delete",
        "param_dev",
        "power",
        "light",
        "param_gprs",
        "param_net",
        "param_wifi",
        "baudrate",
        "config_pgm",
        "dispatch",
        "pgm_play",
        "param_svr",
        "upgrade",
        "tab_scan",
        "text_part_update",
        "sync",
        "param_timing",
        "expend",
        "play_list",
        "cancel",
        "param_inspect",
        "param_io",
        "set_id",
        "gamma",
        "delay_start",
        "pgm_flicker",
        "show_dev",
        "ts_pgm_upload",
        "rotate",
        "game",
        "RTDraw",
        "ani_num",
        "bluetooth",
        "timing",
        "test"];
    var count = arr.length;
    for (var i = 0; i < count; i++) {
        var pRet = cmd[arr[i]];
        if (null != pRet)
            return { item: pRet, 'type': i };
    }
    return null;
}
function write_data_header(pData, offset, len, sno, type_data, type_cmd) {
    bytes_deal_1.bytes_write_int(pData, offset, LED_Head_TLV, 2, false);
    bytes_deal_1.bytes_write_int(pData, offset + 2, 0xFFFF, 2, false);
    bytes_deal_1.bytes_write_int(pData, offset + 4, len + 4, 2, false);
    bytes_deal_1.bytes_write_int(pData, offset + 6, sno & 0xFFFF, 2, false);
    pData[offset + 8] = type_data;
    pData[offset + 9] = type_cmd;
    return 10;
}
function build_pkt(sno, data, type_data, type_cmd, type) {
    if (null == data || data.length == 0)
        return new Uint8Array(0);
    L_count_pkt = L_count_pkt + 1;
    var bChecksum = ((type_data >> 7) == 1);
    var pos = 0;
    var ret = null;
    var len_pkt = data.length + 10;
    var len_cs = bChecksum ? 2 : 0;
    len_pkt += len_cs;
    switch (type) {
        case 1: {
            ret = new Uint8Array(2 + len_pkt);
            bytes_deal_1.bytes_write_int(ret, 0, len_pkt, 2);
            pos = 2;
            break;
        }
        case 2: {
            ret = new Uint8Array(6 + len_pkt);
            bytes_deal_1.bytes_write_int(ret, 0, len_pkt + 2, 2);
            bytes_deal_1.bytes_write_int(ret, 4, len_pkt, 2);
            pos = 6;
            break;
        }
        case 0:
        default:
            ret = new Uint8Array(len_pkt);
            break;
    }
    var len_header = write_data_header(ret, pos, data.length + len_cs, sno, type_data, type_cmd);
    bytes_deal_1.memcpy_buf(ret, pos + len_header, data, 0, data.length);
    if (bChecksum) {
        var cs = 0;
        len_pkt += pos;
        for (var i = pos; i < len_pkt - 2; ++i)
            cs += ret[i];
        bytes_deal_1.bytes_write_int(ret, ret.length - 2, cs, 2);
    }
    return ret;
}
function build_data_cmd(cmd, sno, res) {
    L_type_cmd = TYPE_CMD_TLV_Set;
    var obj = get_obj_cmd(cmd);
    if (obj == null)
        return null;
    var pItem = obj.item;
    var ret = null;
    switch (obj['type']) {
        case 0: return build_data_rt_show(pItem, sno, res);
        case 1: {
            L_type_cmd = TYPE_CMD_TLV_Get;
            ret = build_data_get(pItem);
            break;
        }
        case 2:
            ret = build_data_del(pItem);
            break;
        case 3:
            ret = build_data_param_dev(pItem);
            break;
        case 4:
            ret = build_data_power(pItem);
            break;
        case 5:
            ret = build_data_light(pItem);
            break;
        case 11:
            ret = build_data_dispatch_pgm(pItem);
            break;
        case 12:
            ret = build_data_pgm_play(pItem);
            break;
        case 14: {
            if (res != undefined && res.length > 0)
                return build_data_upgrade(pItem, sno, res[0]);
            return null;
        }
        case 27:
            ret = build_data_pgm_flicker(pItem);
            break;
        case 28:
            ret = build_data_show_dev(pItem);
            break;
        case 30:
            ret = build_data_rotate(pItem);
            break;
        case 31:
            ret = build_data_game(pItem);
            break;
        case 32:
            ret = build_data_RTDraw(pItem);
            break;
        case 33:
            ret = build_data_ani_num(pItem);
            break;
        case 34:
            ret = build_data_bluetooth(pItem);
            break;
        case 35:
            ret = build_data_timing(pItem);
            break;
        default: {
            return null;
        }
    }
    ;
    return build_pkt(sno, ret, L_type_data, L_type_cmd, 1);
}
function parse_data(obj, res) {
    L_count_pkt = 0;
    if (obj.cmd != null) {
        return build_data_cmd(obj.cmd, obj.sno, res);
    }
    else if (obj.pkts_program != null) {
        return build_data_pgm(obj.pkts_program, obj["id_res"], get_json_number(obj, "ts_update", 0), obj.sno, res);
    }
    else
        return null;
}
exports.parse_data = parse_data;
function get_count_pkt() {
    return L_count_pkt;
}
exports.get_count_pkt = get_count_pkt;
